import { gql } from 'apollo-boost'

export const UPDATE_PUSH = gql`
  mutation UpdatePush($input: UpdatePushEndpointInput!) {
    updatePushEndpoint(input: $input)
  }
`
